import Image from 'next/image';
import React from 'react';

import type { CardT } from '@/utils/contentfulTypes';

import { ContentfulTextContainer } from '../ContentfulTextContainer';

interface OneSizeFitsNoneProps {
  data: CardT[];
}

const OneSizeFitsNone: React.FC<OneSizeFitsNoneProps> = ({ data }) => {
  return (
    <section className="py-11 px-4 bg-white font-light md:px-20 md:py-20">
      <div className="width-1440">
        <h2 className="font-light text-[36px] text-center md:text-5xl">One size fits none</h2>
        <p className="max-w-[62ch] mx-auto text-center mt-5 md:text-xl">
          Your genetics are unique and influence how your body responds to different foods,
          exercises, and lifestyle changes. It&apos;s time to stop working out like everyone else
          and start using a plan personally tailored to your body.
        </p>
        <div className="mt-20 space-y-12 md:space-y-24">
          {data.map(({ headline, subheadline, image, text }) => (
            <div
              key={headline}
              className="space-y-10 lg:space-y-0 lg:flex lg:flex-row-reverse lg:items-center lg:gap-20"
            >
              <Image
                src={image.url}
                alt="one size fits none"
                height={500}
                width={616}
                className="object-cover mx-auto"
              />
              <div>
                <div className="uppercase text-alter-black-60 font-normal">{subheadline}</div>
                <h3 className="mt-4 font-light text-[28px] leading-tight md:text-[40px]">
                  {headline}
                </h3>
                <ContentfulTextContainer
                  markdown={text}
                  className="mt-6 text-alter-black-80 [&_p]:text-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OneSizeFitsNone;
